export class DeviceUtil {

    public static isPc(): boolean {
        return window.innerWidth > 800;
    }

    public static isSp(): boolean {
        return !this.isPc();
    }
}